export const SIGNATURE_FONT = 'Cedarville Cursive';
export const SIGNATURE_FONT_SIZE = 24;
